import { request } from "@/axios";

/**
 * 活动权益响应类型
 */
export interface ActivityRightsResp {
  /** 活动信息列表 */
  activityInfos?: ActivityInfo[];
  /** 万能渲染剩余次数 */
  universalRendering: number;
  /** 自由视角剩余次数 */
  freePerspective: number;
  /** Qwen 自由视角剩余免费次数（一键成稿 module 60 与自由画布 module 61 共享） */
  qwenFreePerspective?: number;
  /** 全能拆分未付费免费体验剩余次数（上限 10，永久有效，不受 Beta 开关影响；会员恒为 0） */
  gameUiSplitTrial?: number;
  /** 全能拆分会员每日限免剩余次数（上限 10，次日重置；未付费用户恒为 0） */
  gameUiSplitDaily?: number;
  /** 全能拆分会员累计限免剩余次数（上限 10，永久；未付费用户恒为 0） */
  gameUiSplitTotal?: number;
  /** 全能拆分 Beta 限免开关；false 时会员直接恢复计价（TB-9531） */
  gameUiSplitBetaEnabled?: boolean;
}

export interface ActivityInfo {
  /** 剩余次数 */
  count: number;
  /** 活动结束时间 */
  endTime: string;
  /** 活动名称 */
  name: string;
  /** 活动开始时间 */
  startTime: string;
  /** 活动状态（0：未开启，1：已开启，2：已结束） */
  status: number;
  /** 活动类型 */
  type: string;
}

/**
 * 获取活动权益
 * @returns 活动权益信息
 */
export function getActivityRights(userId?: string | number) {
  const hasUserId = userId !== undefined && userId !== null && String(userId) !== "";
  return request<ActivityRightsResp>({
    api: "/api/rights/getActivityRights",
    method: "get",
    params: hasUserId ? { userId } : undefined,
    notToast: false
  });
}
